/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Sign_In_RequiredInputs */



/**
* | output |
* | --- |
* | "Sign in Required" |
*
* @param {Profile_Sign_In_RequiredInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_sign_in_required = /** @type {((inputs?: Profile_Sign_In_RequiredInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Sign_In_RequiredInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Connexion requise")
	if (locale === "es") return /** @type {LocalizedString} */ ("Inicio de sesión requerido")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Login Necessário")
	if (locale === "it") return /** @type {LocalizedString} */ ("Accesso Richiesto")
	return /** @type {LocalizedString} */ ("Sign in Required")
});